export default __webpack_public_path__ + "static/webRotator/svg/63b57f6c1b66de37db5df7c13f199e9a.svg";